import React from 'react';
import './styles/table.css';
import classNames from 'classnames';

type TableProps = {
  headers: string[];
  rows: (TableRow | (string | number)[])[];
  columnWidths?: string[];
  highlightStar?: boolean;
  smallText?: boolean;
  noLines?: boolean;
  useExtraResultBorder?: boolean;
};

type TableRow = {
  cells: (string | number)[];
  isUser?: boolean;
};

function Table(props: TableProps) {
  const {
    headers,
    rows,
    columnWidths = [],
    highlightStar = false,
    smallText,
    noLines,
    useExtraResultBorder,
  } = props;

  const tableClass = classNames('table', {
    'table-small-text': smallText,
    'table-no-lines': noLines,
  });

  const normalizedRows: TableRow[] = rows.map((row) => (Array.isArray(row) ? { cells: row } : row));

  return (
    <table className={tableClass}>
      {columnWidths.length > 0 && (
        <colgroup>
          {columnWidths.map((width, i) => (
            <col key={i} style={{ width }} />
          ))}
        </colgroup>
      )}

      <thead className="bg-[var(--backdrop)]">
        <tr>
          {headers.map((header, i) => (
            <th
              key={i}
              className={`table-cell ${i === 0 && highlightStar ? 'text-[var(--yellow)]' : ''}`}
            >
              {header}
            </th>
          ))}
        </tr>
      </thead>

      <tbody>
        {normalizedRows.map((row, rowIndex) => (
          <React.Fragment key={rowIndex}>
            {rowIndex === 10 && useExtraResultBorder && (
              <tr>
                <td colSpan={headers.length} className="py-1">
                  <div
                    className="w-full h-[2px] bg-repeat-x"
                    style={{
                      backgroundImage:
                        'repeating-linear-gradient(to right, var(--btn-border) 0, var(--btn-border) 6px, transparent 6px, transparent 12px)',
                      backgroundSize: '12px 2px',
                    }}
                  />
                </td>
              </tr>
            )}
            <tr>
              {row.cells.map((cell, colIndex) => (
                <td
                  key={colIndex}
                  className={classNames('table-cell text-center', {
                    'font-bold': row.isUser,
                    'truncate max-w-[10ch] overflow-hidden whitespace-nowrap': colIndex === 1,
                  })}
                >
                  {cell}
                </td>
              ))}
            </tr>
          </React.Fragment>
        ))}
      </tbody>
    </table>
  );
}

export default Table;
